import React, { useState } from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Avatar from '@mui/material/Avatar'
import { Text, Tip, Paragraph } from '../../../assets/Text'
import STM from '../../../helpers/TimeManage'
import MUIIconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider'
import { IconButton } from '../../../assets/Buttons'
import * as Icons from '../../../assets/Icons'
import UserInteractionHelper from '../../../helpers/UserInteractionHelper'
/**
 * usage:
    <SupportiveMessages key={`match-supportive-messages-${idx}`} display_name={msg.sender_display_name} message={msg.message} time={msg.sent_time} />
 */

const SupportiveMessages = props => {
    // console.log("supportive msgs", props)
    let [isconnected, updateIsconnected] = useState(props.connected || false)

    const onConnect = async () => {
        try
        {
            const matchId = props.senderId
            const userId = props.userId
            // console.log(`user ${matchId} and ${userId} are connected? ${isconnected}`)
            if(!isconnected)
            {
                const addContactResult = await UserInteractionHelper.addContact(userId, matchId)
                const addChatResult = await UserInteractionHelper.addChatRoom(userId, matchId) // also add the chatroom
                if(addContactResult.hasOwnProperty('status') && addContactResult.status === 'success') //note, I didn't check the error control for the chat room as you can have more than one 
                {
                    // alert("connected")
                    updateIsconnected(true)
                    return true
                }
                /** this process for some reasons fails many times, 
                 * so if the first time doesn't succeed, I decide to try a second time 
                 * */
                const removeContactResult = await UserInteractionHelper.removeContact(userId, matchId)
                if(removeContactResult.hasOwnProperty('status') && removeContactResult.status === 'success')
                {
                    const addContactResult = await UserInteractionHelper.addContact(userId, matchId)
                    const addChatResult = await UserInteractionHelper.addChatRoom(userId, matchId) // also add the chatroom
                    if(addContactResult.hasOwnProperty('status') && addContactResult.status === 'success') //note, I didn't check the error control for the chat room as you can have more than one 
                    {
                        // alert("connected")
                        updateIsconnected(true)
                        return true
                    }
                    // second attempt failed
                    return false
                }
                return false
            }
            
            const removeContactResult = await UserInteractionHelper.removeContact(userId, matchId)
            if(removeContactResult.hasOwnProperty('status') && removeContactResult.status === 'success')
            {
                // alert("disconnected")
                updateIsconnected(false)
                return true
            }
            return false

        }
        catch(e)
        {
            // alert("an error happened")
            console.log(e)
            return false
        }
    }

    let date = new Date()
    if(props.hasOwnProperty('time') && props.time !== null)
    {
        date = new Date(props.time)
    }

    if(props.enableDelete)
    {
    return (<React.Fragment>
        <Divider />

        <Grid item>

            <Grid container direction={'row'} justify={"center"} align={"center"} sx={{
                py: {
                    xs: 2, sm: 2, md: 2
                },
                px: {
                    xs: 2
                }
            }}>
                <Grid item xs={1.5} sm={1} md={1}>
                <Avatar sx={{
                        width: {
                            md: '72px',
                            sm: '72px',
                            xs: '36px'
                        },
                        height: {
                            md: '72px',
                            sm: '72px',
                            xs: '36px'
                        },
                        mb: {
                            md: '16px',
                            sm: '16px',
                            xs: '8x'
                        },
                        bgcolor: 'primary.main'
                    }}>{(props.display_name && props.display_name.length > 1) ? `${props.display_name[0].toUpperCase()}${props.display_name[1].toUpperCase()}`:(props.display_name && props.display_name.length > 0) ? `${props.display_name[0].toUpperCase()}`: '?'}</Avatar>
                </Grid>

             {/** right details panel */}
                 <Grid item xs sm md
                         sx={{
                             display: 'flex',
                             alignItems: 'center'
                         }}
                     >
                         <Stack 
                            sx={{
                                width: '100%',
                                p: 1,
                                pl: 2,
                            }}
                         direction={"column"} justify={"flex-start"} align={"flex-start"}>
                             <Box sx={{
                                 bgcolor: 'background.light',
                                 width: '100%',
                                 p: 1,
                                 borderRadius: 2,
                                 border: `1px solid`,
                                 borderColor: 'primary.main'
                             }}>
                                <Paragraph variant='body2'  align="left" sx={{ color: 'info.main' }}>{props.message}</Paragraph>
                             </Box>
                             <Paragraph variant='caption' align="right" sx={{ color: 'primary.main' }}>{STM.convertTimeToString(date)}</Paragraph>

                         </Stack>
                 </Grid>

                <Grid item xs={1.5} sm={1} md={1}>
                    <MUIIconButton aria-label="delete" onClick={props.handleDelete} >
                       <Icons.DeleteIcon style={{
                            width: '36px',
                            height: '36px'
                        }} />
                     </MUIIconButton>
                </Grid>
            </Grid>

        </Grid>
    </React.Fragment>)
    }

    return (<Grid item>
    <Stack 
        direction={"row"}
        sx={{
            maxWidth: {
                md: '542px',
                sm: '536px',
                xs: '396px'
            },
            bgcolor: 'customPink.main',
            py: 2,
            px: 3,
            boxShadow: 2,
            borderRadius: 1,
            mx: 'auto'
        }}
    >
        {/** left avatar and connect */}
        <Box item xs={4} sm={4} md={4}>
            <Grid container>
                <Stack
                    direction={"column"}
                    spacing={1}
                    align={"center"}
                >
                    <Box>
                        <Avatar sx={{
                                width: {
                                    md: '72px',
                                    sm: '72px',
                                    xs: '48px'
                                },
                                height: {
                                    md: '72px',
                                    sm: '72px',
                                    xs: '48px'
                                },
                                mb: {
                                    md: '16px',
                                    sm: '16px',
                                    xs: '8x'
                                },
                                bgcolor: 'primary.main'
                            }}>{(props.display_name && props.display_name.length > 1) ? `${props.display_name[0].toUpperCase()}${props.display_name[1].toUpperCase()}`:(props.display_name && props.display_name.length > 0) ? `${props.display_name[0].toUpperCase()}`: '?'}</Avatar>
                    </Box>
                    <Box
                        sx={{
                            display: {
                                xs: 'none',
                                sm: 'block',
                                md: 'block'
                            }
                        }}
                    >
                        <IconButton onClick={onConnect} color={isconnected ? "primary":"lightBtn"} title={isconnected ? props.lang.connected:props.lang.connect} icon={isconnected ? <Icons.ConnectedIcon style={{ width: '36px', height: '36px'}} />:<Icons.SupportMsgIcon1 style={{ width: '36px', height: '36px'}} />} />
                    </Box>
                    <Box
                        sx={{
                            display: {
                                md: 'none',
                                sm: 'none',
                                xs: 'block'
                            }
                        }}
                    >
                        <MUIIconButton 
                            sx={{
                                borderRadius: 2,
                                boxShadow: 2,
                                bgcolor: isconnected ? 'primary.main':'lightBtn.main',
                            }}
                            onClick={onConnect} aria-label="connect" title="" >
                            {isconnected ? <Icons.ConnectedIcon color={isconnected ? "primary":"lightBtn"} style={{ width: '36px', height: '36px'}} />:<Icons.SupportMsgIcon1 style={{ width: '36px', height: '36px'}} />}
                        </MUIIconButton>
                    </Box>
                </Stack>
            </Grid>

        </Box>

        {/** right details panel */}
        <Box 
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    ml: {
                        xs: 1,
                        sm: 2,
                        md: 2
                    }
                }}
            >
                <Stack direction={"column"}>
                        <Box>
                            <Paragraph variant='h6' sx={{ color: 'primary.main' }}>{props.display_name}</Paragraph>
                            <Paragraph variant='body2' sx={{ color: 'info.main' }}>{STM.convertTimeToString(date)}</Paragraph>
                            <Paragraph variant='body2' sx={{ mt: 1, color: 'info.main' }}>{props.message}</Paragraph>
                        </Box>
                </Stack>
        </Box>


    </Stack>
    </Grid>)
    // return (<><Grid item xs={10} className='d-flex mx-auto my-3'>

    //     <Grid item xs={2}>
    //         <div className='match-avatar-sm mx-auto'>
    //             <Text className='p-0 m-0'>{props.display_name.length > 1 ? `${props.display_name[0].toUpperCase()}${props.display_name[1].toUpperCase()}`:`${props.display_name[0].toUpperCase()}`}</Text>
    //         </div>
    //     </Grid>

    //     {props.enableDelete ? 
    //         <Grid item xs={10} className='supportive-message-bubble p-3 d-flex justify-content-between align-items-center'>
    //             <Grid item xs={11}><Text className='p-0 m-0'>{props.message}</Text></Grid>
    //             <Tooltip title="Delete" placement="top-end">
    //                 <IconButton aria-label="delete" onClick={props.handleDelete} >
    //                 <DeleteIcon />
    //                 </IconButton>
    //             </Tooltip>
    //             {/*<Grid item xs={1} className='text-center cursor-pointer'><Icon className='fas fa-times' onClick={props.handleDelete} /></Grid>*/}
    //         </Grid>
    //         :
    //         <Grid item xs={10} className='supportive-message-bubble p-3 d-flex justify-content-between align-items-center'>
    //             <Text className='p-0 m-0'>{props.message}</Text>
    //         </Grid>
    //     }


    //     </Grid>
        
    //     <Grid item xs={10} className='mx-auto d-flex justify-content-end'>
    //         <Tip>{STM.convertTimeToString(date)}</Tip>
    //     </Grid>
    
    // </>)
}


export default SupportiveMessages